import { Outlet } from "react-router-dom";
import Header from "../components/Common/Header.jsx";

const PosLayout = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header />
      <div style={{ flex: 1, padding: "20px"}}>
        <Outlet />
      </div>
    </div>
  );
};

export default PosLayout;
